<template>
  <Modal :title="$t('ADD_NEW_MEMBER')">
    <template #content>
      <div class="modal" tabindex="-1" aria-modal="true" role="dialog">
        <div class="modal__content min-w-[70vw]">
          <div class="h-full flex flex-col items-center justify-evenly">
            <div>
              <img src="@/assets/img/common/hand.png" alt="" />
            </div>
            <p
              class="text-center max-w-[592px]"
              v-html="$t('ADD_NEW_MEMBER__SUCCESS')"></p>
          </div>
          <div class="modal__actions">
            <button
              type="button"
              class="btn btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModal()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="25"
                viewBox="0 0 26 25"
                fill="none">
                <path
                  d="M2 23L23.9203 1.07969"
                  stroke="white"
                  stroke-width="3"></path>
                <path
                  d="M24 23L2.07969 1.07969"
                  stroke="white"
                  stroke-width="3"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script setup lang="ts">
import { sleep } from '~/utils'

const emit = defineEmits(['closed'])

function closeModal() {
  emit('closed')
  window.location.reload()
}
</script>
<style scoped>
.modal {
  grid-template-columns: max-content;
  grid-template-areas: 'content';

  &::before {
    content: url('@/assets/img/common/left-kite.png');
    position: absolute;
    left: 0;
    bottom: 0;
  }

  &::after {
    content: url('@/assets/img/common/right-kite.png');
    position: absolute;
    right: 0;
    bottom: 0;
  }

  &__content {
    --bg-color: transparent;
  }
}
</style>
